module.exports = __webpack_public_path__ + "static/website-development-19a44ff7f36a24d07b97b6c1d52e1a37.svg";